import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { timeImages } from '@/assets/img/common';
import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { H2, StringXSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';
import { selectSpecContractBaseExtentionTime } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

interface AdditionalTimeInfoProps {
  className: string;
  kind: SpecContractType | PaidSpecContractType;
}

const AdditionalTimeInfo: FC<AdditionalTimeInfoProps> = ({
  className,
  kind,
}) => {
  const { t } = useTranslation();
  const value = useAppSelector((state) =>
    selectSpecContractBaseExtentionTime(state, kind),
  );

  return (
    value && (
      <div className={cn('flex flex-col items-center gap-1', className)}>
        <Picture
          className="size-12"
          img={timeImages.hourglass.png}
          webp={timeImages.hourglass.webp}
          alt="hourglass"
        />
        <H2 weight="bold" className="!text-gold">
          +{value}
        </H2>
        <StringXSmall className="capitalize !text-white/40">
          {t('minutes')}
        </StringXSmall>
      </div>
    )
  );
};

export { AdditionalTimeInfo };
